import { gql } from "@apollo/client";

export const GET_STUDIES_LIST_BY_IDS_QUERY = gql`
  query StudiesByIds($ids: [ID!]!) {
    studiesByIds(ids: $ids) {
      _id
      modality
      study_date
      series_ids
    }
  }
`;
